// extracted by mini-css-extract-plugin
export default {"text":"CampaignSidebarRate_text__S+oVv","name":"CampaignSidebarRate_name__mpTTT","percent":"CampaignSidebarRate_percent__YYz7P","container":"CampaignSidebarRate_container__uPlkd"};